import React from 'react';
import styled from 'styled-components';
import { Container, Box, Loading } from '@cubeyou-team/hx-react-components';
import VerticalCentered from './VerticalCentered';

const StyledInitLayout = styled.div`
  width: 100%;
`;

const InitLayout = () => (
  <StyledInitLayout>
    <VerticalCentered>
      <Container size="xsmall">
        <Box minHeight="150px">
          <Loading hideMode isLoading />
        </Box>
      </Container>
    </VerticalCentered>
  </StyledInitLayout>
);

export default InitLayout;
